/**
 * @author  Agence Dn'D <contact@dnd.fr>
 * @license https://opensource.org/licenses/osl-3.0.php Open Software License (OSL 3.0)
 * @link    https://www.dnd.fr/
 */

document.querySelectorAll('[data-swatches-toggle]').forEach((toggle) => {
    toggle.addEventListener('click', () => {
        const wrapper = toggle.closest('.fake-variants-swatches--color-list-wrapper');
        const isOpen = toggle.classList.contains('is-open');

        wrapper.querySelectorAll('.fake-variants-swatches--color-item.is-hidden, .fake-variants-swatches--color-item.is-visible-toggled').forEach((item) => {
            if (isOpen) {
                item.classList.add('is-hidden');
                item.classList.remove('is-visible-toggled');
            } else {
                item.classList.remove('is-hidden');
                item.classList.add('is-visible-toggled');
            }
        });

        toggle.classList.toggle('is-open', !isOpen);
    });
});